import { Form } from '@kanda-libs/ks-component-ts';
import type { FunctionComponent } from 'react';
import Content from './Content';
import useCalculator from './useCalculator';

const Calculator: FunctionComponent = function () {
  const { rates, bnplRates, aprs, form, onSubmit } = useCalculator();

  return (
    <Form id="finance-calculator" form={form} onSubmit={onSubmit}>
      <Content rates={rates} bnplRates={bnplRates} aprs={aprs} />
    </Form>
  );
};

export default Calculator;
